<template>
  <modal
    name="previewImageModal"
    :click-to-close="true"
    :styles="styles"
    :width="'100%'"
    :height="'100%'"
    @closed="onClose"
    @before-open="beforeOpen"
    @opened="opened"
  >
    <div class="preview-image-modal">
      <div
        class="img-box"
        :style="imgBoxStyle"
      >
        <img
          :src="srcUrl"
          :style="imgStyle"
          @load="changSize"
        >
        <div
          class="del-btn"
          :style="closeBtnStyle"
          @click="close"
        >
          <iconfont
            style="font-size:14px;color:white;"
            name="#icon10-45guanbianniu"
          ></iconfont>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  data() {
    return {
      srcUrl: '',
      styles: {
        width: '100%',
        height: '100%',
        borderRadius: 0,
        overflow: 'visible',
        backgroundColor: 'transparent',
        boxShadow: 'none'
      },
      imgStyle: 'height:100%',
      imgEle: null,
      closeBtnStyle: {},
      imgBoxStyle: {
        width: '64.4%',
        height: '64.4%'
      }
    };
  },
  mounted() {
    //console.log('mounted mounted');
    window.addEventListener('resize', this.changSize);
    this.changSize();
  },
  methods: {
    beforeOpen({ params }) {
      //0.644
      this.srcUrl = params.url;
      //console.log('beforeOpen',params);
    },
    onClose() {
      window.removeEventListener('resize', this.changSize);
    },
    close() {
      this.$modal.hide('previewImageModal');
    },
    changSize(e) {
      if (e && e.target && e.target.offsetHeight) {
        this.imgEle = e.target;
      }
      //console.log('window', window.innerWidth);

      if (this.imgEle && this.imgEle.offsetHeight) {
        //console.log('this.imgEle this.imgEle', this.imgEle.width);
        if(this.imgEle.naturalWidth <= this.imgEle.offsetWidth
        && this.imgEle.naturalHeight <= this.imgEle.offsetHeight){
          this.imgBoxStyle = {
            width: this.imgEle.naturalWidth - 2 + 'px',
            height: this.imgEle.naturalHeight + 'px'
          };
          //console.log('have image offset', this.imgBoxStyle);
        }else{
          this.imgBoxStyle = {
            width: this.imgEle.offsetWidth - 2 + 'px',
            height: this.imgEle.offsetHeight + 'px'
          };
          //console.log('no image offset', this.imgBoxStyle);
        }

      } else {
        let w = 0.644 * window.innerWidth;
        this.imgBoxStyle = {
          width: w + 'px',
          height: (w * 9) / 16 + 'px'
        };
        //console.log('no image ele', this.imgBoxStyle);
      }
      let bw = 0.03125 * window.innerWidth;
      this.closeBtnStyle = {
        width: bw + 'px',
        height: bw + 'px',
        right: -bw - 30 * (window.innerWidth / 1920) + 'px'
      };

    },
    opened() {
      this.changSize();
      //console.log('opened opened opened');
    }
  }
};
</script>

<style lang="scss" scoped>
.preview-image-modal {
  position: relative;
  width: 100%;
  height: 100%;
  // background: #00000099;
  display: flex;
  justify-content: center;
  align-items: center;
  .img-box {
    background: transparent;
    position: relative;
    width: 64.4%;
    height: 64.4%;
    .del-btn {
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 60px;
      height: 60px;
      background: #ffffff44;
      border-radius: 50%;
      &:hover{
        cursor: pointer;
        background: #00000044;
      }
    }
  }
}
</style>
